import { RiEyeOffLine } from "@remixicon/react";
import React, { ReactElement } from "react";
import { Dropdown } from "react-bootstrap";
import { useTheme } from "../../../contexts/Theme";
import { TicketItem } from "../../../contexts/ticket-state";
import useDeleteConfirm from "../../confirm/Delete";

interface RedactMessageActionProps {
    text: string;
    iconOnly?: boolean;
    ticketMessageId: string;
    ticketItem?: TicketItem;
}

export default function RedactMessageAction({
    ticketMessageId, text, iconOnly, ticketItem,
}: RedactMessageActionProps): ReactElement {
    const theme = useTheme();

    const confirm = useDeleteConfirm<string>(messageId => {
        ticketItem?.redactMessage(messageId);
    }, () => text, "Redact", "Are you sure you want to redact", "Redact");

    return (
        <>
            {confirm.element}

            <Dropdown.Item
                onClick={() => confirm.setDeleting(ticketMessageId)}
                className={theme.isV3 ? "" : "text-white"}
                title={iconOnly ? "Redact Message" : undefined}
            >
                {iconOnly ? <RiEyeOffLine /> : "Redact Message"}
            </Dropdown.Item>
        </>
    );
}

RedactMessageAction.defaultProps = {
    iconOnly: false,
    ticketItem: undefined,
};
